export const giveawaysRoutes = {
    giveawayHistoryRouteSelector: () => '/giveaway-history',
};
